import React from "react";
import { API_BASE } from "../../admin/api";

export default function PartnerCard({ item, onEdit, onDelete }) {
  const imgSrc = item.image ? `${API_BASE}${item.image}` : null;

  return (
    <article className="partner-card">
      <div className="partner-card__thumb">
        {imgSrc ? (
          <img src={imgSrc} alt={item.name} loading="lazy" />
        ) : (
          <div className="partner-card__thumb--empty">No Image</div>
        )}
      </div>

      <div className="partner-card__body">
        <h3 className="partner-card__title">{item.name}</h3>

        <div className="partner-card__actions">
          <button className="btn btn--ghost" onClick={() => onEdit(item)}>
            Edit
          </button>
          <button className="btn btn--danger" onClick={() => onDelete(item.id)}>
            Delete
          </button>
        </div>
      </div>
    </article>
  );
}